<script>
import {mapActions} from "vuex";

export default {
  name: "SuggestEventDialog",
  data: () => ({
    dialogOpen: false,
    input: null,
    submitted: false,

  }),
  computed: {
    isInputValid() {
      return this.input && this.input.trim().length > 0;
    }
  },
  watch: {
    dialogOpen(newVal) {
      if (!newVal) {
        this.input = null;
        this.submitted = false;
      }
    }
  },
  methods: {
    ...mapActions("veranstaltungen", ["suggestEvent"]),
    async onSuggestClick() {
      this.submitted = await this.suggestEvent(this.input);
    }
  }
}
</script>

<template>
<v-dialog v-model="dialogOpen" width="660">
  <template v-slot:activator="{ on, attrs }">
    <v-btn small v-bind="attrs" v-on="on">
      <v-icon small left>$lightbulb</v-icon>
      Veranstaltungsthema vorschlagen
    </v-btn>
  </template>
  <v-card>
    <template v-if="!submitted">
    <v-card-title class="suggest-headline">
      <div style="width: calc(100% - 36px)">Was bewegt Sie derzeit – und sollte Thema einer Veranstaltung sein?</div>
      <v-btn icon class="close_icon__custom" @click="dialogOpen = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <p>Nutzen Sie die Gelegenheit, Ihre Vorschläge einzubringen und zur Gestaltung zukünftiger Veranstaltungen beizutragen.</p>
      <label>Ihre Nachricht</label>
      <v-textarea v-model="input" background-color="rgb(232,212,223)" rows="3" dense hide-details filled outlined/>
      <v-btn @click="onSuggestClick" :disabled="!isInputValid" color="primary" class="mt-5">Idee einreichen</v-btn>
    </v-card-text>
    </template>
    <template v-else>
      <v-card-title class="justify-end pt-5">
        <v-btn icon class="close_icon__custom" @click="dialogOpen = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="success-headline mb-2 text-center">Vielen Dank!</div>
      <v-card-text class="px-15 text-center">Ihr Vorschlag wurde erfolgreich eingereicht. Wir schätzen Ihr Engagement und werden Ihre Idee prüfen.</v-card-text>
    </template>
  </v-card>
</v-dialog>
</template>

<style scoped>
.suggest-headline {
  font-size: 20px;
  line-height: 24px;
  word-break: break-word;
}

label {
  font-size: 12px;
  font-weight: bold;
}

.success-headline {
  font-size: 30px !important;
  line-height: 20px !important;
  font-weight: 500 !important;
}
</style>